import { Globe2, Check } from "lucide-react";
import { STORES, POPULAR_STORES, REGIONS } from "@/constants/catalog";
import { cn } from "@/lib/utils";
import { t } from "@/i18n";

const Chip = ({ active, onClick, children, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId} data-active={active}
    className={cn("rounded-md border px-3 py-1.5 text-sm transition-all flex items-center gap-1.5",
      active ? "bg-primary/15 border-primary/60 text-primary" : "border-border text-muted-foreground hover:text-foreground hover:border-foreground/30")}>
    {active && <Check className="h-3.5 w-3.5" />}{children}
  </button>
);

export const StepDistribution = ({ rel, set }) => {
  const terr = rel.territories;
  const toggleCountry = (c) => set({ territories: { ...terr, countries: terr.countries.includes(c) ? terr.countries.filter((x) => x !== c) : [...terr.countries, c] } });
  const toggleStore = (s) => set({ stores: rel.stores.includes(s) ? rel.stores.filter((x) => x !== s) : [...rel.stores, s] });
  const allStores = rel.stores.length === STORES.length;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <section className="space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-display font-semibold">{t("Territorios")}</h3>
          <div className="flex gap-1">
            <Chip active={terr.mode === "worldwide"} onClick={() => set({ territories: { mode: "worldwide", countries: [] } })} testId="territory-mode-worldwide"><Globe2 className="h-3.5 w-3.5" /> {t("Mundial")}</Chip>
            <Chip active={terr.mode === "selected"} onClick={() => set({ territories: { ...terr, mode: "selected" } })} testId="territory-mode-selected">{t("Seleccionar")}</Chip>
          </div>
        </div>
        {terr.mode === "worldwide" ? (
          <p className="text-sm text-muted-foreground panel p-4" data-testid="territory-worldwide-note">{t("El lanzamiento se distribuirá en todos los territorios disponibles.")}</p>
        ) : Object.entries(REGIONS).map(([region, codes]) => (
          <div key={region} className="space-y-2">
            <div className="flex items-center justify-between">
              <p className="eyebrow">{t(region)}</p>
              <button type="button" className="text-xs text-primary hover:underline" onClick={() => set({ territories: { ...terr, countries: Array.from(new Set([...terr.countries, ...codes])) } })}>{t("Todos")}</button>
            </div>
            <div className="flex flex-wrap gap-1.5">
              {codes.map((c) => <Chip key={c} active={terr.countries.includes(c)} onClick={() => toggleCountry(c)} testId={`country-${c}`}>{c}</Chip>)}
            </div>
          </div>
        ))}
        {terr.mode === "selected" && <p className="text-xs text-muted-foreground" data-testid="territory-count">{t("{n} territorios seleccionados", { n: terr.countries.length })}</p>}
      </section>
      <section className="space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-display font-semibold">{t("Tiendas / DSP")} <span className="text-xs text-muted-foreground font-normal">{t("({n} plataformas del distribuidor)", { n: STORES.length })}</span></h3>
          <div className="flex gap-3">
            <button type="button" data-testid="stores-select-popular" className="text-xs text-primary hover:underline" onClick={() => set({ stores: Array.from(new Set([...rel.stores, ...POPULAR_STORES])) })}>{t("Principales")}</button>
            <button type="button" data-testid="stores-toggle-all" className="text-xs text-primary hover:underline" onClick={() => set({ stores: allStores ? [] : [...STORES] })}>{t(allStores ? "Quitar todas" : "Seleccionar todas")}</button>
          </div>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {STORES.map((s) => <Chip key={s} active={rel.stores.includes(s)} onClick={() => toggleStore(s)} testId={`store-${s.replace(/[^a-z]/gi, "").toLowerCase()}`}>{s}</Chip>)}
        </div>
        <p className="text-xs text-muted-foreground" data-testid="stores-count">{t("{a} de {b} tiendas", { a: rel.stores.length, b: STORES.length })}</p>
      </section>
    </div>
  );
};
